import { View, Text } from '@react-pdf/renderer';
import React from 'react';
import { dateToMoment } from '@mummssoftware/utils/dates';
import { notesIncluded } from '@mummssoftware/utils/utils';
import { styles } from '../../utils/styles';
import { getTitleFromConfig } from './utils';
import defaults from '../../translations/en.json';

const formatDate = date => {
  const momentObj = dateToMoment(new Date(date));
  return momentObj.format('MM/DD/YY');
};

const makeSelectionString = printSelection => {
  const {
    view
  } = printSelection;
  const hasNotes = notesIncluded(printSelection);
  const notesStr = hasNotes && ` ${defaults.withNotes}`;
  return `${view || ''}${notesStr || ''}`;
};

const makeDateString = (fromDate, toDate) => {
  const hasDates = fromDate && toDate;

  if (hasDates) {
    const formattedFrom = formatDate(fromDate);
    const formattedTo = formatDate(toDate);
    return `${defaults.From} ${formattedFrom} ${defaults.to} ${formattedTo}`;
  }

  return defaults.allDates;
};

export const PrintSelections = ({
  printConfig,
  sourceString
}) => {
  const {
    fromDate,
    toDate
  } = printConfig;
  const dateString = makeDateString(fromDate, toDate);
  const componentKeys = Object.keys(printConfig);
  const selectionStrings = componentKeys.map(key => {
    const selection = printConfig[key]; // dates recorded alongside widget objects in dashboardPrintConfig object

    if (selection && key !== 'fromDate' && key !== 'toDate') {
      // component names stored without spaces or older titles
      const widgetTitle = getTitleFromConfig(key);
      const configStr = makeSelectionString(selection);

      if (configStr && configStr !== '') {
        return `${widgetTitle}: ${configStr}`;
      }

      return widgetTitle;
    }

    return '';
  });
  return /*#__PURE__*/React.createElement(View, {
    style: [styles.width100]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.fontSizeTwelvePt]
  }, sourceString || ' '), selectionStrings.map(widgetStr => /*#__PURE__*/React.createElement(Text, {
    style: [styles.fontSizeEightPt]
  }, widgetStr)), /*#__PURE__*/React.createElement(Text, {
    style: [styles.fontSizeEightPt, styles.fontWeightBold]
  }, dateString));
};